module.exports = __webpack_public_path__ + "static/img/building_placeholder_500x332.bba1a04f.jpg";